import { render, staticRenderFns } from "./Reclaims.vue?vue&type=template&id=1d614fac&scoped=true&"
import script from "./Reclaims.vue?vue&type=script&lang=js&"
export * from "./Reclaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d614fac",
  null
  
)

export default component.exports